
/* injects from baggage-loader */

'use strict';
import $ from 'jquery';
import AlertController from '../alert/alert.controller';
//import infoMonkey from '../../../../app/pages/stage-three/stage-three.controller';

//import { failDialg, feedbackFinishStage, successDialg } from './daily.const';

//import { max, min, sortBy, shuffle } from 'lodash';


export default class DialogDailyController extends AlertController {
    constructor($log, $rootScope, $timeout, $state, Session) {
        'ngInject';
        super($log, $rootScope);
        this.$log = $log;
        this.$state = $state;
        this.$timeout = $timeout;
        this.Session = Session;
        //this.Dialog = Dialog;
        //this.Trophies = Trophies;
        this.stagesNames = [
            "PEIXE-BOI",
            "ONÇA-PINTADA",
            "MACACO BARRIGUDO",
            "TAMANDUÁ"
        ];

        this.stageFeedbacks = [];

        this.stageTimesEntered = [];

        this.stageTotalCompleted = [];

        this.stage

        this.carousel = null;
    }

    bindCarousel(){
        $('.quiz-carousel').slick({
            infinite: false,
            draggable: false,
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1
        });
    }

    $onInit() {
        let infos = this.Session.get();

        for(let i = 0; i < 4; i++){
            this.stageTimesEntered.push(infos.stages[i].timesEntered);
            this.stageTotalCompleted.push(infos.stages[i].totalCompleted);
        }

        /*for(let i = 0; i < 4; i++){
            let feedback = " ainda não foi jogada";
            console.log(feedback);
            if(infos.stages[i].timesEntered > 0){
                feedback = " jogada " + infos.stages[i].timesEntered + " vezes.";
                if(infos.stages[i].timesEntered === infos.stages[i].totalCompleted){
                    feedback += " Todas até o fim.";
                }
                else{
                    feedback += " Apenas " + infos.stages[i].totalCompleted + " até o fim.";
                }
            }

            this.stageFeedbacks.push(feedback);
        }
        */
        this.$timeout(this.bindCarousel.bind(this));
    }
}


// WEBPACK FOOTER //
// ./src/app/components/dialogs/daily/daily.controller.js